import ChatSection from "./ChatSection";

const Dashboard = ({
  newSession,
  setNewSession,
  setActiveSessionId,
  activeSessionId,
  onNewSessionCreated,
  isSidebarCollapsed,
  setIsSidebarCollapsed,
}) => {
  return (
    <div className="dashboard">
      <ChatSection
        activeSessionId={activeSessionId}
        setActiveSessionId={setActiveSessionId}
        newSession={newSession}
        setNewSession={setNewSession}
        onNewSessionCreated={onNewSessionCreated}
        isSidebarCollapsed={isSidebarCollapsed}
        setIsSidebarCollapsed={setIsSidebarCollapsed}
      />
    </div>
  );
};

export default Dashboard;


